import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import SideBar from '../admincomponents/SideBar';
import TopNavBar from '../admincomponents/TopNavBar';
import Footer from '../admincomponents/Footer';
const apiUrl = process.env.REACT_APP_API_URL;
function AdminViewStudent() {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [courseFilter, setCourseFilter] = useState('');
  const [showHidden, setShowHidden] = useState(false);

  const fetchStudents = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
      if (!sessionData || !sessionData.token) {
        setError('You must be logged in to view students.');
        setLoading(false);
        return;
      }
      const response = await axios.get(
        `${apiUrl}/api/admin/students?showHidden=${showHidden ? 1 : 0}&nocache=${Date.now()}`,
        { headers: { Authorization: `Bearer ${sessionData.token}` } }
      );
      if (response.data.success) {
        setStudents(response.data.students);
      } else {
        setError(response.data.message || 'Failed to fetch students.');
      }
    } catch (err) {
      console.error('Error fetching students:', err);
      setError(err.response?.data?.message || 'Error fetching students. Please try again.');
    } finally {
      setLoading(false);
    }
  }, [showHidden]);

  useEffect(() => {
    fetchStudents();
  }, [fetchStudents]);
  const courseOptions = Array.from(
    new Map(
      students
        .filter((s) => s.courseName)
        .map((s) => [s.preferableCourse, s.courseName])
    ).entries()
  ).sort((a, b) => a[1].localeCompare(b[1]));

  const filteredStudents = students.filter((student) => {
    if (statusFilter !== '' && String(student.status) !== statusFilter) return false;
    if (courseFilter && String(student.preferableCourse) !== courseFilter) return false;
    if (search) {
      const q = search.trim().toLowerCase();
      const haystack = [student.firstName, student.lastName, student.email, student.mobile, student.studentid]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      if (!haystack.includes(q)) return false;
    }
    return true;
  });

  const toggleHidden = async (studentId, currentHidden) => {
    const willHide = Number(currentHidden) !== 1;
    if (willHide && !window.confirm('Hide this student? They will be removed from student, fees and assignment listings (their data is kept). You can show them again with the "Show hidden students" filter.')) {
      return;
    }
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
      if (!sessionData || !sessionData.token) {
        setError('You must be logged in to perform this action.');
        return;
      }
      const response = await axios.post(
        `${apiUrl}/api/admin/students/${studentId}/toggle-hidden`,
        {},
        { headers: { Authorization: `Bearer ${sessionData.token}` } }
      );
      if (response.data.success) {
        if (showHidden) {
          setStudents((prev) =>
            prev.map((s) => (s.id === studentId ? { ...s, hidden: response.data.hidden } : s))
          );
        } else {
          // not showing hidden — the row it was just hidden should drop off
          setStudents((prev) => prev.filter((s) => s.id !== studentId));
        }
      } else {
        setError(response.data.message || 'Failed to update student.');
      }
    } catch (err) {
      console.error('Error toggling hidden:', err);
      setError(err.response?.data?.message || 'Error updating student. Please try again.');
    }
  };

  const toggleStatus = async (studentId, currentStatus) => {
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
      if (!sessionData || !sessionData.token) {
        setError('You must be logged in to perform this action.');
        return;
      }
      const response = await axios.post(
        `${apiUrl}/api/admin/students/${studentId}/toggle-status`,
        {},
        {
          headers: {
            Authorization: `Bearer ${sessionData.token}`
          }
        }
      );
      if (response.data.success) {
        setStudents((prevStudents) =>
          prevStudents.map((student) =>
            student.id === studentId ? { ...student, status: student.status === 1 ? 0 : 1 } : student
          )
        );
      } else {
        setError(response.data.message || 'Failed to toggle status.');
      }
    } catch (err) {
      console.error('Error toggling status:', err);
      setError(err.response?.data?.message || 'Error toggling status. Please try again.');
    }
  };
  return (
    <>
      <SideBar />
      <div className="dashboard-main-wrapper">
        <TopNavBar />
        <div className="dashboard-body">
          <div className="breadcrumb-with-buttons mb-24 flex-between flex-wrap gap-8">
            <div className="breadcrumb mb-24">
              <ul className="flex-align gap-4">
                <li>
                  <Link
                    to="/"
                    className="text-gray-200 fw-normal text-15 hover-text-main-600"
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <span className="text-gray-500 fw-normal d-flex">
                    <i className="ph ph-caret-right" />
                  </span>
                </li>
                <li>
                  <span className="text-main-600 fw-normal text-15">Students</span>
                </li>
              </ul>
            </div>
            <div className="flex-align gap-8 flex-wrap">
              {/* <div className="position-relative text-gray-500 flex-align gap-4 text-13">
                <span className="text-inherit">Sort by: </span>
                <div className="flex-align text-gray-500 text-13 border border-gray-100 rounded-4 ps-20 focus-border-main-600 bg-white">
                  <span className="text-lg">
                    <i className="ph ph-funnel-simple" />
                  </span>
                  <select className="form-control ps-8 pe-20 py-16 border-0 text-inherit rounded-4 text-center">
                    <option value="popular" selected>Popular</option>
                    <option value="latest">Latest</option>
                    <option value="trending">Trending</option>
                  </select>
                </div>
              </div>
              <div className="flex-align text-gray-500 text-13 border border-gray-100 rounded-4 ps-20 focus-border-main-600 bg-white">
                <span className="text-lg">
                  <i className="ph ph-layout" />
                </span>
                <select
                  className="form-control ps-8 pe-20 py-16 border-0 text-inherit rounded-4 text-center"
                  id="exportOptions"
                >
                  <option value="" selected disabled>
                    Export
                  </option>
                  <option value="csv">CSV</option>
                  <option value="json">JSON</option>
                </select>
              </div> */}
            </div>
          </div>
          <div className="card mb-24">
            <div className="card-body">
              <div className="row g-16">
                <div className="col-md-4">
                  <label className="text-13 text-gray-500 mb-4 d-block">Search</label>
                  <input
                    type="text"
                    className="form-control py-9"
                    placeholder="Search name, email, mobile, or student ID..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
                <div className="col-md-4">
                  <label className="text-13 text-gray-500 mb-4 d-block">Course</label>
                  <select className="form-control py-9" value={courseFilter} onChange={(e) => setCourseFilter(e.target.value)}>
                    <option value="">All Courses</option>
                    {courseOptions.map(([id, name]) => (
                      <option key={id} value={id}>{name}</option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4">
                  <label className="text-13 text-gray-500 mb-4 d-block">Status</label>
                  <select className="form-control py-9" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                    <option value="">All</option>
                    <option value="1">Active</option>
                    <option value="0">Disabled</option>
                  </select>
                </div>
                <div className="col-12">
                  <div className="form-check mt-8">
                    <input
                      className="form-check-input border-gray-200 rounded-4"
                      type="checkbox"
                      id="showHidden"
                      checked={showHidden}
                      onChange={(e) => setShowHidden(e.target.checked)}
                    />
                    <label className="form-check-label text-13 text-gray-500" htmlFor="showHidden">
                      Show hidden students
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card overflow-hidden">
            <div className="card-body p-0 overflow-x-auto">
              {loading && (
                <div className="alert alert-info mb-0" role="alert">
                  Loading students...
                </div>
              )}
              {error && (
                <div className="alert alert-danger mb-0" role="alert">
                  {error}
                </div>
              )}
              {!loading && !error && students.length === 0 && (
                <div className="alert alert-warning mb-0" role="alert">
                  No students found.
                </div>
              )}
              {!loading && !error && students.length > 0 && filteredStudents.length === 0 && (
                <div className="alert alert-warning mb-0" role="alert">
                  No students match your search/filters.
                </div>
              )}
              {!loading && !error && filteredStudents.length > 0 && (
                <table id="studentTable" className="table table-striped table-sm align-middle mb-0">
                  <thead>
                    <tr>
                      <th className="text-13 text-gray-300">Name</th>
                      <th className="text-13 text-gray-300">Email</th>
                      <th className="text-13 text-gray-300">Mobile</th>
                      <th className="text-13 text-gray-300">Student ID</th>
                      <th className="text-13 text-gray-300">Created</th>
                      <th className="text-13 text-gray-300">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredStudents.map((student) => (
                      <tr key={student.id}>
                        <td style={{ maxWidth: 170 }}>
                          <span className="text-14 fw-medium text-gray-300 d-inline-block text-truncate align-bottom" style={{ maxWidth: 130 }} title={`${student.firstName} ${student.lastName}`}>
                            {student.firstName} {student.lastName}
                          </span>
                          {Number(student.hidden) === 1 && (
                            <span className="badge bg-gray-100 text-gray-600 ms-1 rounded-pill text-13 fw-medium">
                              Hidden
                            </span>
                          )}
                        </td>
                        <td style={{ maxWidth: 190, wordBreak: 'break-word' }}>
                          <span className="text-14 fw-medium text-gray-300">
                            {student.email}
                          </span>
                        </td>
                        <td>
                          <span className="text-14 fw-medium text-gray-300">
                            {student.mobile}
                          </span>
                        </td>
                        <td>
                          <span className="text-14 fw-medium text-gray-300">
                            {student.studentid}
                          </span>
                        </td>
                        <td>
                          <span className="text-14 fw-medium text-gray-300">
                            {new Date(student.created).toLocaleDateString()}
                          </span>
                        </td>
                        <td>
                          <div className="d-flex flex-nowrap gap-1">
                            <Link
                              to={`/admin-edit-student/${student.id}`}
                              className="bg-main-50 text-main-600 py-1 px-8 rounded-pill text-13 hover-bg-main-600 hover-text-white"
                              style={{ whiteSpace: 'nowrap' }}
                            >
                              Edit
                            </Link>
                            <button
                              onClick={() => toggleStatus(student.id, student.status)}
                              className={`py-1 px-8 rounded-pill text-13 ${
                                student.status === 1
                                  ? 'bg-warning-50 text-warning-600 hover-bg-warning-600 hover-text-white'
                                  : 'bg-success-50 text-success-600 hover-bg-success-600 hover-text-white'
                              }`}
                              style={{ whiteSpace: 'nowrap' }}
                            >
                              {student.status === 1 ? 'Disable' : 'Enable'}
                            </button>
                            <button
                              onClick={() => toggleHidden(student.id, student.hidden)}
                              className={`py-1 px-8 rounded-pill text-13 ${
                                Number(student.hidden) === 1
                                  ? 'bg-success-50 text-success-600 hover-bg-success-600 hover-text-white'
                                  : 'bg-gray-100 text-gray-600 hover-bg-gray-600 hover-text-white'
                              }`}
                              style={{ whiteSpace: 'nowrap' }}
                            >
                              {Number(student.hidden) === 1 ? 'Unhide' : 'Hide'}
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
            <div className="card-footer flex-between flex-wrap">
              <span className="text-gray-900">
                Showing {filteredStudents.length} of {students.length} entries
              </span>
              <ul className="pagination flex-align flex-wrap">
                <li className="page-item active">
                  <a
                    className="page-link h-44 w-44 flex-center text-15 rounded-8 fw-medium"
                    href="#"
                  >
                    1
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
export default AdminViewStudent;